$(document).ready(function(){


  const loadProductDetails = (productJson,productId,$this) => {

    let gridItem = $this.parents(`.cart_product_grid`);
//     console.log(gridItem)
    if((productJson.title).indexOf("|") > -1){
      gridItem.find(".color-swatch__option-title").text(`${(productJson.title).split("|")[1]}`);
      gridItem.find(".product-title").text(`${(productJson.title).split("|")[0]}`);
    }else{
      gridItem.find(".color-swatch__option-title").text(`${(productJson.title)}`);
      gridItem.find(".product-title").text(`${(productJson.title)}`);
    }
    let price = productJson.price - 2000;
    let mainPrice = theme.Shopify.formatMoney(price,theme.money_format)
    gridItem.find(".theme-money").text(`${(theme.Shopify.formatMoney(price,theme.money_format)).replace(".00", "")} + ${(theme.Shopify.formatMoney(2000,theme.money_format)).replace(".00", "")} Recycling Credit`);


    /* For Image */
    const getPadding = (aspectRatio)=>{
      let padding = 1;
      return ((padding / aspectRatio)* 100 )
    }
    let ImageHtml =`<div class="rimage-outer-wrapper" style="max-width: ${productJson.media[0].width} px">
<div class="rimage-wrapper " style="padding-top:${getPadding(productJson.media[0].aspect_ratio)}%">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt=""
data-srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${productJson.media[0].src}_1024x1024.png?v=1626405866" alt="${productJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;
    gridItem.find(".product-image").empty().append(ImageHtml);
    gridItem.find(".size-swatch__option-inner-container").empty();
    let count = 0;
    let availableClass = "";
    for(let variant of productJson.variants){
      count++;
      variant.available ? availableClass = "": availableClass = "unavailable";

      let sizeBoxHtml = `<div data-test-colors="${variant.title}" data-variant-title="${variant.title}" data-variant-id="${variant.id}" class="${availableClass} size-swatch__option ${productJson.variants > 1 ? '' : 'active' } enabled">
<div class="size-option-selector">
<span>${variant.title}</span>
</div>
</div>`;


      gridItem.find(".size-swatch__option-inner-container").append(sizeBoxHtml);
      gridItem.find('select[name="id"]').append($('<option>', {
        "value": variant.id,
        "data-title": variant.title,
        "data-available": variant.available,
        "text": variant.title,
        "disabled":!variant.available
      }));
    }
  }
  $(document).on("click", ".color-option-selector", function(){
//     console.log($(this));
    let currentBtn = $(this);
    let productHandle = $(this).data("handle");
    let productId = $(this).data("id");
    currentBtn.parents(".color-swatch__option-inner-container").find(".color-swatch__option").removeClass("active");
    currentBtn.parent(".color-swatch__option").addClass("active");
    let productJson = JSON.parse($(`#product_json-${productHandle}`).html());
    if(productJson){
//       console.log(productJson);
      let newGridUrl = `/products/${productJson.handle}`;
      currentBtn.parents(".cart_product_grid").find(".product-link").attr("href", newGridUrl);
      loadProductDetails(productJson, productId,currentBtn);
    }
  });

  $(document).on("click", ".size-swatch__option", function(){
    $(this).parent(".size-swatch__option-inner-container").find(".size-swatch__option").removeClass("active");
    let variantId = $(this).data("variant-id");
    let variantTitle = $(this).data("variant-title");
    $(this).addClass("active");
    if($(this).hasClass("unavailable")){
      $(".modal_product_button_size").show();
      $(".modal_product_button").hide();
    }
    else{
      $(".modal_product_button_size").hide();
      $(".modal_product_button").show();

      $(this).parents(".modal_body").find("select[name='id']").val(variantId);
      $(this).parents(".modal_body").find("select[name='id'] option").removeAttr("selected");
      $(this).parents(".modal_body").find("select[name='id'] option:selected").attr("selected", "selected");
    }


//     console.log($(this).parents(".modal_body").find("select[name='id']").val());

    $(".modal_product_size_title span").text(variantTitle);
  });

  const onPageLoad = () =>{
    $(".cart_product_grid").each(function(){
      $(this).find(".color-option-selector:first").click();
//       console.log($(this).find(".color-swatch__option.active script").html());
      if($(this).find(".color-swatch__option.active script").html()){
      let productJson = JSON.parse($(this).find(".color-swatch__option.active script").html());
        $(this).find(".product-title").text((productJson.title).split("|")[0]);
        $(this).find(".color-swatch__option-title").text((productJson.title).split("|")[1]);
        const getPadding = (aspectRatio)=>{
          let padding = 1;
          return ((padding / aspectRatio)* 100 )
        };
        let firstImageHtml =`<div class="rimage-outer-wrapper" style="max-width: ${productJson.media[0].width} px">
        <div class="rimage-wrapper " style="padding-top:${getPadding(productJson.media[0].aspect_ratio)}%">
        <img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt=""
        data-srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${productJson.media[0].src}_720x.png?v=1626405866 720w, ${productJson.media[0].src}_900x.png?v=1626405866 900w, ${productJson.media[0].src}_1080x.png?v=1626405866 1080w, ${productJson.media[0].src}_1296x.png?v=1626405866 1296w, ${productJson.media[0].src}_1512x.png?v=1626405866 1512w, ${productJson.media[0].src}_1728x.png?v=1626405866 1728w, ${productJson.media[0].src}_2048x.png?v=1626405866 2048w">
        <noscript>
        <img src="${productJson.media[0].src}_1024x1024.png?v=1626405866" alt="${productJson.title}" class="rimage__image">
        </noscript>
        </div>
        </div>`;

        $(this).find(".product-image").empty().append(firstImageHtml);

        let price = productJson.price - 2000;
        $(this).find(".cart_product_price").text(`${(theme.Shopify.formatMoney(price,theme.money_format)).replace(".00", "")} + ${(theme.Shopify.formatMoney(2000,theme.money_format)).replace(".00", "")} Recycling Credit`);


        $(this).find(".size-swatch__option-inner-container").empty();
        let count = 0;
        let availableClass = "";


        for(let variant of productJson.variants){
//           console.log(variant);
          count++;
          variant.available ? availableClass = "": availableClass = "unavailable";

          let sizeBoxHtml = `<div data-test-colors="${variant.title}" data-variant-title="${variant.title}" data-variant-id="${variant.id}" class="${availableClass} size-swatch__option ${productJson.variants > 1 ? '' : 'active' } enabled">
<div class="size-option-selector">
<span>${variant.title}</span>
</div>
</div>`;
//           console.log($(this).find(".size-swatch__option-inner-container"));
          $(this).find(".size-swatch__option-inner-container").append(sizeBoxHtml);


          $(this).find('select[name="id"]').append($('<option>', {
            "value": variant.id,
            "data-title": variant.title,
            "data-available": variant.available,
            "text": variant.title,
            "disabled":!variant.available
          }));
        }
      }
    });

    getProgressBar();
  }
  onPageLoad();

  $(document).on("click", ".cart_product_submit", function(){
    let variantId = $(this).parents(".cart_product_grid").find(".size-swatch__option.active").attr("data-variant-id"),
    threshold = this.closest('.cart_gift')?.getAttribute('data-threshold'),
    uid = this.closest('.cart_gift')?.getAttribute('data-id'),
    location = !!this.closest('.cart_gift');

    console.log(threshold)

    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1,
        'properties': {
          ...location && {'_gwp': true },
          ...threshold && {'_gwpThreshold': threshold },
          ...uid && {'_gwpUid': uid }
        }
       }]
     };

     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => {
        $("#cart_drawer").empty();
        renderCart();
        jQuery.getJSON('/cart.js', function(cart) {
          $(".header_icon div").html(cart.item_count);
        });
     })
     .catch((error) => {
       console.error('Error:', error);
       document.dispatchEvent(new CustomEvent('theme:loading:end'));
     });

  });

  $(document).on("click", ".drawer_minus,.drawer_plus", function(){
  	let itemKey = $(this).data("key");
    let itemQty = $(this).data("quantity");
    changeQuantity(itemKey, itemQty);
  });

  $(document).on("click", ".mini-cart__item-remove", function(e) {
    e.preventDefault();
    let itemKey = $(this).data("key");
    let itemQty = 0;
    console.log(itemKey)
    changeQuantity(itemKey, itemQty);
  });

  function changeQuantity(itemKey, itemQty){

    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: itemKey,
        quantity: itemQty
      },
      success: function success(product) {
        document.dispatchEvent(new CustomEvent('mini-cart:refresh'))
//         $("#cart_drawer").empty();
//         renderCart();
//         jQuery.getJSON('/cart.js', function(cart) {
// //           console.log(cart);
//           $(".header_icon div").html(cart.item_count);
//         });
      },
      error: function error(XMLHttpRequest) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
//         console.log(XMLHttpRequest)
      }
    });
  }

  function getProgressBar(){
    let currentCartPrice = $(document).find("#cartTotalAmount").val();
    let freeShippingAmount = $(document).find("#freeShippingAmount").val();
    let underFreeShippingText = window.theme.settings.underFreeShippingText;
    let overFreeShippingText = window.theme.settings.overFreeShippingText;

    let percentage = ( freeShippingAmount - currentCartPrice / freeShippingAmount ) * 100;

    var progress = currentCartPrice / 100;
    var maxPrice = freeShippingAmount / 100;

    var diff = (maxPrice - progress);
    var finaldiff = null;
    if (parseFloat(progress) >= parseFloat(maxPrice)) {
      var tota_progress = 100;
    } else {
      var tota_progress = (progress * 100) / maxPrice;
    }

    if (diff <= 0) {
      finaldiff = "0.00";
      $(document).find(".cart_progress_text:not(.totalShippingAmt) p").html(`${overFreeShippingText}`);
      $(document).find(".totalShippingAmt").hide();
    } else {
      finaldiff = diff.toFixed(2);
      $(document).find(".cart_progress_text:not(.totalShippingAmt) p").html(`${(underFreeShippingText).replace("{{amount}}", `$${finaldiff}` )}`);
      $(document).find(".totalShippingAmt").show();
    }

    $(document).find(".progress_bar .progress").css("width",tota_progress+"%");
    //     $(".cart_progress_text p").text(finaldiff);
    //$(".cart_progressbar .right__text .currency").text(Currency.symbol+""+(finaldiff).replace(".", ","));
//     console.log(percentage)

  }

  function renderCart(){
    $.ajax({
      type: 'GET',
      url: '/cart?view=cart-drawer',
      success: function (data) {
        const htmlDom = new DOMParser().parseFromString(data, 'text/html');
        $("#cart_drawer").html(htmlDom.body.querySelector("#cart_drawer").innerHTML);
        $("#cart_drawer").find(".cart_product_grid").each(function(){
          $(this).find(".color-option-selector:first").click();
        });

        getProgressBar();
      }
    });
  }
});
